import KnowledgeCenter from './KnowledgeCenter'

export default KnowledgeCenter
